import { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { CheckIcon, DocumentDuplicateIcon, QrCodeIcon, XMarkIcon } from '@heroicons/react/24/outline';

interface WalletAddressProps {
  label: string;
  address: string;
}

export function WalletAddress({ label, address }: WalletAddressProps) {
  const [showQR, setShowQR] = useState(false);
  const [copied, setCopied] = useState(false);

  const copyAddress = async () => {
    await navigator.clipboard.writeText(address);
    setCopied(true);
    const resetCopied = () => setCopied(false);
    setTimeout(resetCopied, 1000);
  };

  return (
    <>
      <div className="flex items-center gap-2">
        <span className="text-gray-600">{label}:</span>
        <span className="font-mono text-sm text-gray-900">{address}</span>
        <div className="flex -space-x-1">
          <button
            onClick={copyAddress}
            className={`p-1.5 ${copied ? 'text-green-600' : 'text-gray-500 hover:text-gray-700'} transition-colors`}
            title="Copy address"
          >
            {copied ? <CheckIcon className="w-4 h-4" /> : <DocumentDuplicateIcon className="w-4 h-4" />}
          </button>
          <button
            onClick={() => setShowQR(true)}
            className="p-1.5 text-gray-500 hover:text-gray-700 transition-colors"
            title="Show QR code"
          >
            <QrCodeIcon className="w-4 h-4" />
          </button>
        </div>
      </div>

      {/* QR Code Modal */}
      {showQR && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl">
            <div className="flex items-center justify-between mb-4">
              <div className="w-6 h-6" /> {/* Spacer */}
              <button
                onClick={() => setShowQR(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <div className="bg-white p-4 rounded border-gray-200">
              <div className="aspect-square w-full">
                <QRCodeSVG 
                  value={address} 
                  width="100%" 
                  height="100%"
                  className="w-full h-full"
                />
              </div>
            </div>
            <div className="mt-4 font-mono text-sm text-gray-600 text-center break-all">
              {address}
            </div>
          </div>
        </div>
      )}
    </>
  );
} 